import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-white">
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-16">
        <div className="text-center space-y-8">
          {/* Brand & Location */}
          <div className="space-y-3">
            <p 
              className="text-sm text-[#A39383] font-light tracking-wide"
              style={{ fontFamily: "'Playfair Display', serif", fontWeight: 300 }}
            >
              MIA Atelier
            </p>
            <p 
              className="text-xs text-[#B5A89A] font-light"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              Abuja, Nigeria
            </p>
            <div className="space-y-1 pt-2">
              <p 
                className="text-xs text-[#B5A89A] font-light"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                hello@miaatelier.co
              </p>
              <p 
                className="text-xs text-[#B5A89A] font-light"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                +234 803 214 3826
              </p>
              <p 
                className="text-xs text-[#B5A89A] font-light"
                style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
              >
                miaatelier.co
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-2 pt-4">
            <a
              href="https://instagram.com/miaatelier.co"
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-[#A39383] hover:text-[#2C2C2C] transition-colors duration-500 tracking-wide uppercase"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              Instagram
            </a>
            <span className="text-[#D4C4B0]">·</span>
            <Link
              to="/shop"
              className="text-xs text-[#A39383] hover:text-[#2C2C2C] transition-colors duration-500 tracking-wide uppercase"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              Private Orders
            </Link>
            <span className="text-[#D4C4B0]">·</span>
            <Link
              to="/size-guide"
              className="text-xs text-[#A39383] hover:text-[#2C2C2C] transition-colors duration-500 tracking-wide uppercase"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              Size Guide
            </Link>
            <span className="text-[#D4C4B0]">·</span>
            <Link
              to="/shipping-returns"
              className="text-xs text-[#A39383] hover:text-[#2C2C2C] transition-colors duration-500 tracking-wide uppercase"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              Shipping & Returns
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
